import { render, staticRenderFns } from "./SharePositionPro.vue?vue&type=template&id=1f30bf35&scoped=true&"
import script from "./SharePositionPro.vue?vue&type=script&lang=js&"
export * from "./SharePositionPro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f30bf35",
  null
  
)

export default component.exports